export default {
    "GENERAL": {
        "TOGGGLE_NAVIGATION": "Naviation",
        "OK": "Ok",
        "CANCEL": "Cancel",
        "YES": "Yes",
        "NO": "No",
        "BACK": "Back",
        "SAVE": "Save",
        "SAVING": "Saving ...",
        "SAVED": "Saved",
        "ADD": "Add",
        "REMOVE": "Remove",
        "DELETE_MODEL": "Are you sure to delete :{model} ?",
        "DELETE": "Delete",
        "DELETING": "Deleting ...",
        "DELETED": "Deleted",
        "DONE": "Done",
        "EDIT": "Edit",
        "SEND": "Send",
        "SENT": "Sent",
        "SUCCESS": "Success",
        "ERROR": "Error",
        "NOTFOUND": "404 - Not found",
        "CREATED_AT": "Created at",
        "UPDATED_AT": "Updated at",
        "IMAGE": "Image",
        "IMAGES": "Images",
        "IMPORT": "Import",
        "FILTER": "Filter",
        "LOADING": "Loading ...",
        "AND": "And",
        "OR": "Or",
        "FIELD": "Field",
        "VALUE": "Value",
        "OPERATOR": "Operator",
        "CONDITION": "Condition",
        "RELATION": "Relation",
        "EQUAL": "Equals",
        "NOT_EQUAL": "Not equals",
        "NEW": "New",
        "ON_SITE": "On site",
        "YEAR": "Year",
        "FILE": "File",
        "ON_MOBILE": "On mobile",
        "ON_MAP": "On map",
        "LEFT": "Left",
        "RIGHT": "Right",
        "UPLOAD": "Upload",
        "LINK": "Link",
        "TITLE": "Title",
        "DATE": "Date",
        "TEXT": "Text",
        "VIDEO": "Video",
        "VIDEO_ID": "Video ID",
        "NEXT_PAGE": "&gt;",
        "LAST_PAGE": "&gt;&gt;",
        "PREVIOUS_PAGE": "&lt;",
        "FIRST_PAGE": "&lt;&lt;",
        "RECOMMENDATIONS": "Recommendations",
        "SEARCH": "Search",
        "PROGRAM": "Program",
        "TOP": "Top program",
        "ROUTE": "Route",
        "ROUTES": "Routes",
        "TRAVEL_TIME": "Time (s)",
        "UID": "Identifier",
        "BATTERY": "Battery",
        "LAST_DATA_DATE": "Last data",
        "START": "Start",
        "RETURN": "Return",
        "COLOR": "Color",
        "PUBLISHING": "Publishing...",
        "PUBLISHED": "Published",
        "UNPUBLISHING": "Unpublishing...",
        "UNPUBLISHED": "Unpublished",
        "GALLERY_YEAR": "Year",
        "GALLERY_DAY": "Day",
        "HIDDEN": "Is hidden",
        "NAME": "Name",
        "POSITION": "Position",
        "EMAIL": "Email",
        "PHONE": "Phone",
        "DESCRIPTION": "Description",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/general.js